<template>
    <div id="work-week-page">
        <div class="top-buttons">
            <ui5-button
                @click="updateWorkweek"
                :disabled="saving"
            >
                <div>
                    <spinner v-if="saving" />
                    <div>{{ trans('pages.work_week.save') }}</div>
                </div>
            </ui5-button>
            <ui5-button @click="$router.push('/employees')">
                {{ trans('pages.work_week.cancel') }}
            </ui5-button>
        </div>

        <loader v-if="loading" />
        <div
            class="days"
            v-else-if="days"
        >
            <template v-for="day in days">
                <div
                    class="day"
                    :key="'day.' + day.day"
                >
                    <ui5-label class="week-name">
                        {{ weekDays[day.day - 1] }}
                    </ui5-label>
                    <ui5-label>{{ trans('pages.work_week.from') }}</ui5-label>
                    <ui5-input
                        type="Text"
                        :disabled="saving"
                        :value="day.startTime"
                        @input="day.startTime = $event.target.value"
                    />
                    <ui5-label>{{ trans('pages.work_week.to') }}</ui5-label>
                    <ui5-input
                        type="Text"
                        :disabled="saving"
                        :value="day.endTime"
                        @input="day.endTime = $event.target.value"
                    />
                    <ui5-label>{{ trans('pages.work_week.with') }}</ui5-label>
                    <ui5-input
                        type="Text"
                        :disabled="saving"
                        :value="day.breakTime"
                        @input="day.breakTime = $event.target.value"
                    />
                    <ui5-label>
                        {{ trans('pages.work_week.break_minutes') }}
                    </ui5-label>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import { weekDays } from '../shared/schedule';
import Loader from '../components/loader/Loader';
import Spinner from '../components/loader/Spinner';
import workweekApi from '../api/workweek';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { Spinner, Loader },
    mixins: [localization],
    mounted() {
        this.init();
    },
    computed: {
        weekDays: () => weekDays,
    },
    data() {
        return {
            loading: false,
            saving: false,
            days: null,
        };
    },
    methods: {
        init() {
            this.loading = true;
            workweekApi
                .fetchWorkweek()
                .then((response) => {
                    this.days = Object.values(response.data.data);
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.work_week.errors.load_error')
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        updateWorkweek() {
            const workweek = this.days.map((x) => {
                return {
                    day: parseInt(x.day.toString()),
                    startTime: x.startTime,
                    endTime: x.endTime,
                    breakTime: x.breakTime,
                };
            });
            this.saving = true;
            workweekApi
                .updateWorkweek(workweek)
                .then(() => {
                    showInfoMessage(
                        this.trans('pages.work_week.success.saved')
                    );
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.work_week.errors.save_error')
                    );
                })
                .finally(() => {
                    this.saving = false;
                });
        },
    },
};
</script>
